import React , {Component } from 'react';
import AUX from '../../hoc/Aux_';

class Faq extends Component{

    render(){
        return(
            <AUX>
                <section className="section bg-light" id="faq">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-8">
                                <div className="text-center">
                                    <div className="title-icon">
                                        <i className="mdi mdi-comment-question-outline"></i>
                                    </div>
                                    <h3 className="section-title pt-5">Frequently Asked Questions</h3>
                                    <p className="section-subtitle pt-3 text-muted">Pertanyaan yang banyak ditanyakan dan jawabannya</p>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center mt-5">
                            <div className="col-lg-6 faq-side">
                                <div className="faq pt-5">
                                    <p className="text-uppercase user-title mb-1">untuk pengguna</p>
                                    <div className="faq-ans">
                                        <h3 className="faq-title"><i className="mdi mdi-help-circle"></i> Apa kepanjangan dari KUGI?</h3>
                                        <p className="faq-sub-title text-muted pt-2">Katalog Unsur Geografi Indonesia.</p>
                                    </div>
                                </div>
                                <div className="faq pt-5">
                                    <p className="text-uppercase user-title mb-1 mb-1">untuk pengguna</p>
                                    <div className="faq-ans">
                                        <h3 className="faq-title"><i className="mdi mdi-help-circle"></i> Apa kegunaan KUGI?</h3>
                                        <p className="faq-sub-title text-muted pt-2">Katalog Unsur Geografi Indonesia(KUGI), yang dibuat oleh BIG bersama walidata geospasial (misal: Kementrian/Lembaga) berfungsi untuk membuat standar data spasial, yang terdiri dari penamaan dataset, penamaan fitur, penamaan kolom, hingga isi kolom(dibuat berdasarkan skala, misalnya fitur bangunan hanya tampil di skala besar).</p>
                                    </div>
                                </div>
                                <div className="faq pt-5">
                                    <p className="text-uppercase user-title mb-1">untuk pengguna</p>
                                    <div className="faq-ans">
                                        <h3 className="faq-title"><i className="mdi mdi-help-circle"></i> Apa itu ina geoportal?</h3>
                                        <p className="faq-sub-title text-muted pt-2">Ina-Geoportal sebagai geoportal nasional yang menghubungkan berbagai Kementerian, Lembaga, Provinsi, dan Daerah yang menjadi mitra penghubung simpul Jaringan Informasi Geospasial Nasional (JIGN). Kini pengguna dapat menikmati fitur analisis data, geoprocessing, geotagging, drag and drop data file dengan teknologi mapviewer berbasis opensource.</p>
                                    </div>
                                </div>

                            </div>

                            <div className="col-lg-6 faq-side ">
                                <div className="faq pt-5">
                                    <p className="text-uppercase user-title mb-1">untuk pengguna</p>
                                    <div className="faq-ans">
                                        <h3 className="faq-title"><i className="mdi mdi-help-circle"></i> Siapa yang membuat website ini ?</h3>
                                        <p className="faq-sub-title text-muted pt-2">Badan Informasi Geospasial adalah lembaga pemerintah nonkementerian Indonesia yang bertugas melaksanakan tugas pemerintahan di bidang informasi geospasial.</p>
                                    </div>
                                </div>
                                <div className="faq pt-5">
                                    <p className="text-uppercase user-title mb-1">untuk pengguna</p>
                                    <div className="faq-ans">
                                        <h3 className="faq-title"><i className="mdi mdi-help-circle"></i> Apa itu Metaservice ?</h3>
                                        <p className="faq-sub-title text-muted pt-2">Meta Data Services adalah teknologi repositori berorientasi objek yang dapat diintegrasikan dengan sistem informasi perusahaan atau dengan aplikasi yang memproses metadata</p>
                                    </div>
                                </div>
                                <div className="faq pt-5">
                                    <p className="text-uppercase user-title mb-1">untuk pengguna</p>
                                    <div className="faq-ans">
                                        <h3 className="faq-title"><i className="mdi mdi-help-circle"></i> Apa itu 3D map?</h3>
                                        <p className="faq-sub-title text-muted pt-2">salah satu teknik proyeksi yang mengubah objek atau ruang menjadi bidang proyeksi untuk video. Objek atau ruang yang dimaksud dapat berupa gedung, ruang interior, dan juga objek-objek kecil seperti furniture, dekorasi, dll.</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
           </AUX>
        );
    }
}

export default Faq;
